export const FEATURE_FLAG_CUSTOM_SCHEDULE_FROM_TAILORED = "custom-schedule-from-tailored"
